import React, {useEffect, useState} from "react";
import State from "../State";
import PageService from "../Pages/PageService";
import ClipLoader from "react-spinners/ClipLoader";
import ReactMarkdown from "react-markdown";


function History({jsonServer}) {


    const [state] = useState(new State(useState(0)));

    const service = new PageService(jsonServer, state);
    service.entityApi.db = 'content';

    useEffect(() => {
        service.fetchPage('historik');
    }, []);

    if (state.errorMsg) {
        return (<span className="errorMessage">{state.errorMsg}</span>);
    }

    if (state.loading || !state.page) {
        return (<div><ClipLoader loading={state.loading} size={150}/></div>);
    }

    return (
        <div>
            <h1 className="page-title">{state.page.headline}</h1>

            <p className="lead">{state.page.preamble}</p>

            {!state.page.snippets ? '' : state.page.snippets.map(s =>
                (
                    <p>

                        <ReactMarkdown>{s.content}</ReactMarkdown>
                    </p>

                ))
            }

        </div>
    );
}

export default History;